import React, { useState } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function MotivoCancelamentoNfse(props) {

    const [reason, setReason] = useState('');

    const handleClose = () => {
        props.setOpenModalMotivoCancelamento(false);
    };

    const handleSubmit = (event) => {
        if (!reason) {
            alert('Por favor, insira o motivo do cancelamento.');
            return;
        }

        props.handleCancelNota(props.idNota, reason);
        setReason('');
        handleClose();
    };

    return (
        <>
            <Dialog open={props.openModalMotivoCancelamento}>
                <DialogTitle>Cancelar Nota</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Para cancelar a nota, por favor insira o motivo do cancelamento abaixo.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        required
                        margin="dense"
                        id="motivo"
                        name="motivo"
                        label="Motivo do Cancelamento"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        type="text"
                        fullWidth
                        variant="standard"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Voltar</Button>
                    <Button color="error" onClick={handleSubmit}>
                        Cancelar Nota
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}